// Client-side localized texts for moderation notifications & status
// (notifications are stored with FR fallback text; when meta.moderation is
// present we render fully translated titles/bodies instead).

export const reasonText = (categories, t) => {
  const cats = (categories || []).filter(Boolean);
  if (!cats.length) return t("modstatus.reason_other", "contenu sensible");
  const known = new Set(["nudity", "sexual", "violence", "drugs", "gore", "hate"]);
  return cats
    .map((c) => {
      const key = c === "sexual" ? "nudity" : c;
      return known.has(c) ? t(`modstatus.reason_${key}`, c) : t("modstatus.reason_other", "contenu sensible");
    })
    .filter((v, i, a) => a.indexOf(v) === i)
    .join(", ");
};

const STATUS_KEYS = {
  queued: ["modnotif.queued_title", "modnotif.queued_body"],
  blocked: ["modnotif.blocked_title", "modnotif.blocked_body"],
  removed: ["modnotif.removed_title", "modnotif.removed_body"],
  restored: ["modnotif.restored_title", "modnotif.restored_body"],
};

// Returns { title, body } translated for a moderation notification, or null.
export const modNotifText = (n, t) => {
  const m = n?.meta?.moderation;
  if (!m || !STATUS_KEYS[m.status]) return null;
  const [tk, bk] = STATUS_KEYS[m.status];
  const reason = reasonText(m.categories, t);
  return {
    title: t(tk, n.title || ""),
    body: (t(bk, n.body || "") || "").replace("{reason}", reason),
  };
};
